import React from "react";
import "./App.sass";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import GuasasapoTv from "./components/Guasasapotv";
import Introtv from "./components/Introtv";
import Granada from "./components/Granada";
import Trincheta from "./components/Trincheta";
import Comedora from "./components/Comedora";
import Guasasapo from "./components/Guasasapo";
import Hibernacion from "./components/Hibernacion";
import GuasasapoCronologia from "./components/GuasasapoCronologia";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/introtv">
          <Introtv />
        </Route>
        <Route path="/granada">
          <Granada />
        </Route>
        <Route path="/trincheta">
          <Trincheta />
        </Route>
        <Route path="/logos">
          <Hibernacion homeMode />
        </Route>
        <Route path="/hibernacion">
          <Hibernacion />
        </Route>
        <Route path="/cronologia">
          <GuasasapoCronologia />
        </Route>
        <Route path="/guasasapo">
          <Guasasapo />
        </Route>
        <Route path="/comedora">
          <Comedora />
        </Route>
        <Route path="/guasasapotv">
          <GuasasapoTv />
        </Route>
        <Route path="/guasasapoTV">
          <GuasasapoTv />
        </Route>
        <Route path="/">
          <Hibernacion homeMode />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
